import axios from 'axios';
import config from '../config'
import * as R from 'ramda';

export const requestWithAuth = () => (
    axios.create({
        baseURL: config.firebase.getApiUrl(),
        headers: {
            Authorization: `${sessionStorage.getItem('t')}`
        },
        crossDomain: true
    })
);

export const request = () => (
    axios.create({
        baseURL: config.firebase.getApiUrl(),
        headers: {
        },
        crossDomain: true
    })
);

export const processErr = e => {
    let tokenExpired = false
    if (!R.isNil(e.response.data.errors)) {
        tokenExpired = e.response.data.errors.message.includes('expired');
    }
    return {
        ...e,
        tokenExpired,
        status: 'fail'
    };
};

export const mockRequest = (success = true) => {
    const data = {
        message: 'MOCK MESSAGE'
    };
    const error = {
        response: { 
            data: { 
                message: 'MOCK ERROR MESSAGE'
            }
        }
    };
    return new Promise((resolve, reject) => {
        if (success) {
            setTimeout(function() {
                resolve(data);
            }, 3000);
        } else {
            setTimeout(function() {
                reject(error);
            }, 1500);
        }
    });
}